import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

export function Persist():boolean
{
  return localStorage.getItem('vuex')!==null
}

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
  login,
  },
  plugins: [new VuexPersistence().plugin],
})


